import SidePanelRecallPickingItemInputs from "../components/SidePanelRecallPickingItemInputs";
import { useSignals } from "@preact/signals-react/runtime";
import { Button } from "react-aria-components";
import { RecallLineItemStatusSmartEnum } from "../../../../../enums/Domain/RecallLineItemStatusSmartEnum";
import { StatusDto } from "../../../../../enums/Domain/Status";
import React from "react";
import { IPicklistItem } from "../../../List/RecallsPickList";
import RecallPickingButtons from "../../../picking/RecallPickingButtons";
import useRecallPickListActions from "../../../picking/useRecallPickListActions";

interface ISidePanelPickListItem {
    recallId: string | undefined,
    selectedItem: IPicklistItem,
    items: IPicklistItem[],
    handleChange: (input: string) => (id: string, x: string | number | boolean | StatusDto) => void;
    nextItem: (() => void) | undefined
    prevItem: (() => void) | undefined
}

export default function SidePanelRecallPickListItem({ recallId, selectedItem, items, handleChange, nextItem, prevItem, onSave, onSubmit }: ISidePanelPickListItem & { onSave?: () => Promise<void>, onSubmit?: () => Promise<void> }) {
    useSignals()
    const { save: saveAction, submit: submitAction } = useRecallPickListActions({
        recallId,
        items
    });

    const save = async () => {
        if (onSave) {
            await onSave();
        } else {
            await saveAction(items);
        }
    };

    const submit = async () => {
        if (onSubmit) {
            await onSubmit();
        } else {
            await submitAction(items);
        }
    };

    return (<div className="display--flex flex__direction--column height--full">
        <div className="display--flex justifyContent--flex-start margin__bottom--xxxs gap--xxs">
            {selectedItem.status.value === RecallLineItemStatusSmartEnum.ToPick.value &&
                <Button type="button" className="button button--primary button--primary--destructive button--small"
                    onPress={() => handleChange("status")(selectedItem.id, new StatusDto(RecallLineItemStatusSmartEnum.Cancelled.value, RecallLineItemStatusSmartEnum.getName()))}>
                    <p className="button-text">Cancel Item</p>
                </Button>
            }
            {selectedItem.status.value === RecallLineItemStatusSmartEnum.Cancelled.value &&
                <Button type="button" className="button button--primary button--small"
                    onPress={() => handleChange("status")(selectedItem.id, new StatusDto(RecallLineItemStatusSmartEnum.ToPick.value, RecallLineItemStatusSmartEnum.getName()))}>
                    <p className="button-text">Uncancel Item</p>
                </Button>
            }
            {selectedItem.status.value === RecallLineItemStatusSmartEnum.Invalid.value &&
                <Button type="button" className="button button--primary button--primary--destructive button--small"
                    onPress={() => handleChange("status")(selectedItem.id, new StatusDto(RecallLineItemStatusSmartEnum.Cancelled.value, RecallLineItemStatusSmartEnum.getName()))}>
                    <p className="button-text">Cancel Item</p>
                </Button>
            }
        </div>
        <SidePanelRecallPickingItemInputs data={selectedItem} handleChange={handleChange} />
        <div className="margin__top--auto">
            <RecallPickingButtons lineItems={items} save={save} submit={submit} Next={nextItem} Prev={prevItem} />
        </div>
    </div>)
}